import { addStyle } from "@/lib/dom/addStyle";
import { after } from "@/lib/dom/after";
import { before } from "@/lib/dom/before";
import { on } from "@/lib/dom/on";
import { removeNode } from "@/lib/dom/removeNode";
import { ready } from "@/lib/ready";
import resetHeight from "./resetHeight"
import { getSize } from "@/lib/dom/getSize";
import { hasClass } from "@/lib/dom/hasClass";

const ExecProductBlockJs = () => {
  const itemSpan = getComputedStyle(document.documentElement).getPropertyValue('--item-span');
  const colLength = parseInt(itemSpan);

  let slickdealsBanner = document.querySelector<HTMLElement>('.slickdeals-banner')

  if (slickdealsBanner) {
    const ph = '<div class="onsale-content-placeholder" style="padding: 0px; display:none;">'
      + '<div class="onsale_smallimg"></div><div class="onsale_name"></div><div class="onsale_ico"></div></div>';

    if (!document.querySelector('#hdDefaultColLength')) {
      document.body.insertAdjacentHTML('beforeend', '<input id="hdDefaultColLength" type="hidden" value="0" />');
    }
    removeNode('.onsale-content-placeholder');

    const hdDefaultColLength = document.querySelector<HTMLInputElement>('#hdDefaultColLength')!;
    const prevColLength = parseInt(hdDefaultColLength.value);
    if (colLength == 4) {
      if (prevColLength == 2 || prevColLength == 3) {
        const outer = slickdealsBanner.outerHTML;
        if (prevColLength == 3) {
          const prev = slickdealsBanner.nextElementSibling!;
          removeNode(slickdealsBanner);
          after(prev, outer)
        }
        else {
          const next = slickdealsBanner.nextElementSibling!.nextElementSibling!;
          removeNode(slickdealsBanner);
          after(next, outer)
        }
        hdDefaultColLength.value = '4';
        addStyle('.slickdeals-banner', 'min-width', 'auto')
      }
    } else if (colLength == 3) {
      if (prevColLength != 3) {
        const outer = slickdealsBanner.outerHTML;
        if (prevColLength == 2) {
          const next = slickdealsBanner.nextElementSibling!;
          removeNode(slickdealsBanner);
          after(next, outer)
        }
        else {
          const prev = slickdealsBanner.previousElementSibling!;
          removeNode(slickdealsBanner);
          before(prev, outer)
        }
        hdDefaultColLength.value = '3'
      }
      slickdealsBanner = document.querySelector<HTMLElement>('.slickdeals-banner')!

      if (slickdealsBanner.previousElementSibling) {
        const size = getSize(slickdealsBanner.previousElementSibling! as HTMLElement)
        addStyle(slickdealsBanner, 'min-width', (size.width * 2) + 'px')
      }
      // $('.slickdeals-banner').css('min-width', $('.slickdeals-banner').prev().width() * 2);
    } else if (colLength == 2) {
      if (prevColLength != 2) {
        const outer = slickdealsBanner.outerHTML;
        removeNode(slickdealsBanner);
        hdDefaultColLength.value = '2'
        const onsale_main = document.querySelector('#onsale_main')!;
        if (onsale_main) {
          onsale_main.insertAdjacentHTML('afterbegin', outer)
        }
      }
    }

    before(document.querySelector('.slickdeals-banner')!, ph);
    before(document.querySelector('.slickdeals-banner')!, ph);
  }
  if (!document.querySelector('.ad-banner') && !document.querySelector('#tempAdBanner')) {
    const ph = '<div style="padding: 0px; display:none;"><div class="onsale_smallimg"></div><div class="onsale_name"></div><div class="onsale_ico"></div><div class="onsale_sku"></div></div>';
    const tempAdBanner = document.querySelector('#tempAdBanner');
    if (tempAdBanner) {
      const adBanner = tempAdBanner.innerHTML!;
      const elList = Array.from(document.querySelectorAll<HTMLElement>('.onsale-content'))

      const productCount =
        elList.filter(el => {
          if (!hasClass(el, 'onsale-content-empty')) {
            return true;
          }
          return false;
        }).length

      let idx = 5 * colLength - 2;
      if (document.querySelector('.slickdeals-banner')) {
        idx--;
      }

      if (productCount > idx) {
        after(elList[idx].parentElement!, adBanner);
        const adBannerEl = document.querySelector('.ad-banner');
        if (adBannerEl) {
          adBannerEl.insertAdjacentHTML('beforeend', ph);
        }

        const onSaleContentEmpty = document.querySelectorAll('.onsale-content-empty');
        onSaleContentEmpty.forEach(res=>{
          removeNode(res.parentElement!);
        })

        removeNode(tempAdBanner)
        // $('#tempAdBanner').remove();
      }

    }
  }


  // 计算高度
  const onsale_main = document.querySelector<HTMLElement>("#onsale_main")
  if (onsale_main) {
    resetHeight(onsale_main)
  }
}

const InitSmallImg = () => {
  ExecProductBlockJs();
}

ready(() => {
  InitSmallImg();
  on(window, 'resize', () => {
    InitSmallImg();
  })
})


ready(() => {
  const hdShoppingCartList = document.querySelector<HTMLInputElement>('#hdShoppingCartList')
  if (hdShoppingCartList && hdShoppingCartList.value.length > 0) {
    // const overlay = '<a class="mask-layer" href="@link"><span class="mask-layer-tips">Item In Cart<i></i></span></a>';
    const arr = hdShoppingCartList.value.split(',');
    if (arr.length > 0) {
      for (let i = 0; i < arr.length; i++) {
        const productItem = document.querySelector('#ProductGrid_' + arr[i])
        if (productItem) {
          // var link = $('#imgBig' + arr[i]).prop('href');
          const link = document.getElementById('imgBig' + arr[i])!.getAttribute('href')!;
          productItem.parentElement!.querySelector('.onsale_img')!.insertAdjacentHTML('beforeend', `<a class="mask-layer" href="${link}"><span class="mask-layer-tips">Item In Cart<i></i></span></a>`)
          // $('#ProductGrid_' + arr[i]).parent().append(overlay.replace('@link', link));
        }
        // if ($('#ProductGrid_' + arr[i]).length > 0) {
        //   var link = $('#imgBig' + arr[i]).prop('href');
        //   $('#ProductGrid_' + arr[i]).parent().append(overlay.replace('@link', link));
        // }
      }
    }
  }
})

/**OOS*/
ready(() => {

  document.querySelectorAll('.OOS-grey').forEach((element) => {
    const layer = element.querySelector('.mask-layer') as HTMLElement | null;

    if (!layer) {
      // Find the link within '.onsale_img a' that does not have the 'video-icon' class
      const linkElement = element.querySelector('.onsale_img a:not(.video-icon)') as HTMLAnchorElement | null;
      const link = linkElement ? linkElement.href : '#';

      // Insert the overlay HTML with the dynamic link
      element.querySelector('.onsale_img')!.insertAdjacentHTML(
        'beforeend',
        `<a class="mask-layer" href="${link}"><img src="https://img66.anypromo.com/frontimg/2020/icon/ico-stock-1.svg" class="ico-outstock" /></a>`
      );
    } else {
      // Insert the out-of-stock icon at the beginning of the existing layer
      layer.insertAdjacentHTML(
        'afterbegin',
        `<img src="https://img66.anypromo.com/frontimg/2020/icon/ico-stock-1.svg" class="ico-outstock" />`
      );
    }
  });
})